import { compare, multiply } from "dinero.js"

import { toDinero, toMonetaryAmount } from "../../../../../../modules/currency/currencyLib"
import { MonetaryAmount } from "../../../../../../modules/currency/currencyTypes"

import { ExtraServiceDetails } from "../../../createOrderTypes"
import { DeliveryOrderLine } from "../../form/formTypes"

// Handles both pricing types: FLAT_FEE (fixed price) and PER_SEAT (price × seats, clamped between min/max)
export const calculateServicePrice = (service: ExtraServiceDetails, seatCount: number): MonetaryAmount => {
    // FLAT_FEE services have a single fixed price regardless of seat count
    if (service.pricingType === "FLAT_FEE" && service.price) {
        return service.price
    }

    // PER_SEAT services: multiply pricePerSeat × seats, then clamp between minimumPrice and maximumPrice
    if (service.pricePerSeat && service.minimumPrice && service.maximumPrice) {
        const raw = multiply(toDinero(service.pricePerSeat), seatCount)
        const min = toDinero(service.minimumPrice)
        const max = toDinero(service.maximumPrice)
        const clamped = compare(raw, min) < 0 ? min : compare(raw, max) > 0 ? max : raw
        return toMonetaryAmount(clamped)
    }

    return service.pricePerSeat ?? service.price ?? { amount: 0, scale: 2, currency: "DKK" }
}

export const isServiceAdded = (delivery: { orderLines: DeliveryOrderLine[] }, serviceId: number) =>
    delivery.orderLines.some((p) => Number(p.id) === Number(serviceId) && p?.isExtraService)
